import React, { useState } from 'react';

interface FormState {
  customTemplate: string;
  title: string;
  description: string;
}

const useCustomTemplateForm = () => {
  const [formState, setFormState] = useState<FormState>({
    customTemplate: '',
    title: '',
    description: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormState({
      customTemplate: '',
      title: '',
      description: '',
    });
  };

  return {
    formState,
    handleChange,
    resetForm,
  };
};

export default useCustomTemplateForm;
